export default "__VITE_ASSET__c7655dff__"